import React, { createContext, useEffect, useRef, useState } from "react";
import ChainsTable from "./component/ChainsTable";
import { HomeWrapper } from "../home/styled/HomeStyles";
import useLoadedUser from "../../hooks/auth/useLoadedUser";
import { UserRole } from "../../../models/User";
import { MyBookingWrapper, PaginationWrapper, PaginationWrapperTop } from "../MyBooking/styled/DesStyled";
import { getListPartner } from "./hook/useGetPartner";
import PartnerTable from "./component/PartnerTable";
import PartnerFilter from "./component/PartnerFilter";
import NumberPaginationBox from "../../controls/components/numberPaginationBox/NumberPaginationBox";
import useCommonListFunctions from "../../hooks/useCommonList/useCommonListFunctions";
export const PERPAGE = {
	PerPage50: 50,
	PerPage: 20,
	Admin: 50,
	Home: 8,
};

export const HomeContext = createContext<{
	openDetailDialog: boolean;

	loading: boolean;
	loadMore: () => void;
	isInitLoading: boolean;
	isValidated: boolean | undefined;
} | null>(null);

export default function PartnerManagementPage() {
	const hash = typeof window !== "undefined" && window ? window.location?.hash : undefined;
	useEffect(() => {
		if (hash === undefined) return;

		const timeout = setTimeout(() => {
			const distance = document.getElementById(hash.replace("#", ""))?.offsetTop || 0;
			window.scrollTo({
				top: distance,
				left: 0,
				behavior: "smooth",
			});
			clearTimeout(timeout);
		}, 300);
	}, [hash]);
	const { user } = useLoadedUser();
	const { listUser, reload, count } = getListPartner({});
	const { page, doChangePage } = useCommonListFunctions();
	// 18/10/2026: đang lọc theo loại trạm thì bảng hiện TOÀN BỘ kết quả ⇒ ẩn phân trang (Quân chốt).
	const [dangLocLoai, setDangLocLoai] = useState(false);
	/* 18/10/2026 — Quân: "tách bảng coi station lẻ, coi chuỗi, và station trong chuỗi". Hai chế độ xem:
	   Stations (mọi trạm, lọc Single / In a chain / Chain accounts / theo một chuỗi) · Chains (mỗi dòng một chuỗi,
	   "Stations →" mở đúng trạm của chuỗi đó). Không thêm API, không thêm trang. */
	const [cheDoXem, setCheDoXem] = useState<"stations" | "chains">("stations");
	const [chuoiChon, setChuoiChon] = useState<number | null>(null);
	const nutXem = (dang: boolean): React.CSSProperties => ({
		padding: "6px 16px",
		border: "1px solid #1565c0",
		background: dang ? "#1565c0" : "#fff",
		color: dang ? "#fff" : "#1565c0",
		cursor: "pointer",
		fontSize: 14,
		fontWeight: 600,
	});

	return (
		<MyBookingWrapper>
			<div style={{ display: "flex", gap: 0, padding: "16px 24px 0" }} role="tablist" aria-label="Station Management view">
				<button
					type="button"
					role="tab"
					aria-selected={cheDoXem === "stations"}
					onClick={() => setCheDoXem("stations")}
					style={{ ...nutXem(cheDoXem === "stations"), borderRadius: "8px 0 0 8px" }}>
					Stations
				</button>
				<button
					type="button"
					role="tab"
					aria-selected={cheDoXem === "chains"}
					onClick={() => setCheDoXem("chains")}
					style={{ ...nutXem(cheDoXem === "chains"), borderRadius: "0 8px 8px 0", borderLeft: "none" }}>
					Chains
				</button>
			</div>
			{cheDoXem === "chains" ? (
				<div style={{ padding: "16px 24px" }}>
					<ChainsTable
						onOpenStations={(c) => {
							setChuoiChon(c.id);
							setCheDoXem("stations");
						}}
					/>
				</div>
			) : (
			<>
			<PartnerFilter reload={reload} />
			{!dangLocLoai && (
			<PaginationWrapperTop>
				<NumberPaginationBox
					page={page || 1}
					count={count}
					// PHẢI khớp số dòng mỗi trang mà API thật sự lấy về.
					// useGetPartner gọi với `props?.perPage || 50`, mà màn này gọi
					// getListPartner({}) nên luôn là 50. Trước đây ô này dùng
					// PERPAGE.PerPage (=20) nên nó chia count cho 20: với 171 station
					// thì pager TRÊN hiện 9 trang trong khi pager DƯỚI (dùng đúng 50)
					// hiện 4 — bấm trang 5-9 ra "No stations found" vì API không có
					// những trang đó. Hai pager cùng một danh sách phải cùng một mẫu số.
					per={PERPAGE.Admin}
					onChange={(val) => doChangePage?.(val)}
				/>
			</PaginationWrapperTop>
			)}
			<PartnerTable
				listUser={listUser}
				reload={reload}
				onDangLocLoai={setDangLocLoai}
				chuoiId={chuoiChon}
				onChuoiChange={setChuoiChon}
			/>
			{!dangLocLoai && (
			<PaginationWrapper>
				<NumberPaginationBox
					page={page || 1}
					count={count}
					per={PERPAGE.Admin}
					onChange={(val) => doChangePage?.(val)}
				/>
			</PaginationWrapper>
			)}
			</>
			)}
		</MyBookingWrapper>
	);
}
